module.exports = __webpack_public_path__ + "static/media/Polygon 1arrow.264d0164.svg";